import { render, staticRenderFns } from "./OrderLoadboards.vue?vue&type=template&id=5b05715c&scoped=true&"
import script from "./OrderLoadboards.vue?vue&type=script&lang=js&"
export * from "./OrderLoadboards.vue?vue&type=script&lang=js&"
import style0 from "./OrderLoadboards.vue?vue&type=style&index=0&id=5b05715c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b05715c",
  null
  
)

export default component.exports